module.exports = __webpack_public_path__ + "img/stat1.7853226a.svg";